import { faArrowRight, faSearch } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import cx from 'classnames';
import { ChangeEvent, useEffect, useRef, useState } from 'react';
import Footer from '../footer';
import NavBar from '../nav';
import Search from '../search';
import './index.scss';

const GridButtons = [
  {
    icon: <div className={cx('ic', 'globe')} />,
    name: 'Compliance Solutions, LLC',
    subName: 'Aviation Software Solutions'
  },
  {
    icon: <div className={cx('ic', 'isolation')} />,
    name: 'Fly Compliance, LLC',
    subName: 'FAA Regulation Compliance'
  },
  {
    icon: <div className={cx('ic', 'academic')} />,
    name: 'Pilot Training',
    subName: 'Aviation Syllabus & Curriculum'
  },
  {
    icon: <div className={cx('ic', 'globe')} />,
    name: 'Compliance Management',
    subName: 'Streamlining compliance, scheduling and quoting.'
  },
  {
    icon: <div className={cx('ic', 'isolation')} />,
    name: 'FAA Compliance',
    subName: 'Frequently Asked REgulations.'
  },
  {
    icon: <div className={cx('ic', 'academic')} />,
    name: 'Safety Mangement (SMS)',
    subName: 'Certification and safety management services.'
  }
]

const HomePage = () => {
  const [term, setTerm] = useState<string>('');
  const [inputValue, setInputValue] = useState<string>('')
  const debounce = useRef<NodeJS.Timeout>()
  const [question, setQuestion] = useState<string>('')

  useEffect(() => {
    const searchText = sessionStorage.getItem('searchText')
    if (searchText) {
      setInputValue(searchText)
    }
  }, [])

  useEffect(() => {
    sessionStorage.setItem('searchText', term)
  }, [term])

  useEffect(() => {
    clearTimeout(debounce.current)
    debounce.current = setTimeout(() => {
      setTerm(inputValue)
    }, 500)
  }, [inputValue])

  const onSearch = (e: ChangeEvent<HTMLInputElement>) => {
    setInputValue(e.target.value)

  }

  const onChange = (e: ChangeEvent<HTMLTextAreaElement>) => {
    const value = e.target.value
    if (value.length > 100) {
      return
    }
    setQuestion(e.target.value)
  }

  return <div>
    <NavBar />
    <div className='home'>
      <div className='home__content'>
        <p className='home__content--help-text'>Let us help you out</p>
        <div className='home__content--search-input'>
          <FontAwesomeIcon icon={faSearch} />
          <input placeholder='What are you looking for today?' value={inputValue} onChange={onSearch} />
          <FontAwesomeIcon icon={faArrowRight} />
        </div>
        {!term && <>
          <div className='home__content--grid-buttons'>
            {GridButtons.map((button, idx) =>
              <div className='home__content--grid-button' key={idx}>
                {button.icon}
                <p>{button.name}</p>
                <p>{button.subName}</p>
              </div>)
            }
          </div>
          <div className='home__content--announcement'>
            <div>
              <p>Press Release</p>
              <p>New Collaboration with the US Private Aviation Association (USPAA) - August, 2023</p>
              <p>Fly Compliant, LLC is announcing its collaboration with the US Private Aviation Association (USPAA). USPAA is a new organization dedicated to the interest of part 135 operators. Join us in Nashville September 7th and 8th as Fly Compliant and USPAA will be presenting their goals for the industry.</p>
              <span className='a'>Download Press Release</span>
            </div>
            <div>
              <p>Announcement</p>
              <p>5th Annual Compliance Seminar - August, 2023</p>
              <p>Fly Compliant, LLC is hosting its 5th annual compliance seminar on September 7th and 8th in Nashville. This year we have set a new industry standard, with a less is more approach by introducing "Explicit Procedures" in our manual system. We are removing the bloat and unnecessary content and then offering a back-to-basic approach to training. This approach enhances efficiency and increases safety.</p>
              <span className='a'>Download Press Release</span>
            </div>
          </div>
          <div className='home__content--regulations'>
            <p>Frequently asked regulations</p>
            <div>
              <span>
                <p>Exclusive Use Aircraft</p>
                <p>May a 135 exclusive use aircraft be flown part 91.</p>
                <span className='a'>Get Answer</span>
              </span>
              <span>
                <p>SIC Training</p>
                <p>What type of training is required for a SIC under 135?</p>
                <span className='a'>Get Answer</span>
              </span>
              <span>
                <p>14 CFR 135.269</p>
                <p>May an augmented crew use 135.267 for the rest requirements?</p>
                <span className='a'>Get Answer</span>
              </span>
              <span>
                <p>14 CFR 135.267(c)</p>
                <p>May a crewmember exceed 14 hours of duty in 24 hour period?</p>
                <span className='a'>Get Answer</span>
              </span>
            </div>
          </div>
        </>}
      </div>
    </div>
    {!term && <>
      <div className='promotions'>
        <div></div>
        <div>
          <p>Promo Section</p>
          <p>July 7-8, 2025</p>
          <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vivamus a dolor vitae quam elementum hendrerit. Vestibulum ligula lorem, condimentum nec ultricies ut, convallis sit amet quam. Donec tempor, dui ultricies.</p>
          <button className='btn primary'>
            Learn More
            <FontAwesomeIcon icon={faArrowRight} />
          </button>
        </div>
      </div>
      <div className='messages'>
        <p>Ask a question about regulatory compliance.</p>
        <textarea value={question} onChange={onChange} />
        <p>{question.length}/100</p>
        <div>
          <button className='btn primary'>
            Send Message
          </button>
        </div>
      </div>
      <div className='quotes'>
        <p>"If you can't explain it simply, you don't understand it well enough."</p>
        <p>- Albert Einstein</p>
      </div>
    </>}
    {term && <Search term={term} />}
    <Footer />
  </div>
}

export default HomePage